import CallbackOperationsApi from "@js-app/office/api/callback-operations.api";

class CallbackOperationsService {
    async getCallbackInformationService(operationId) {
        return await CallbackOperationsApi.getCallbackInformation(operationId);
    }
}

export default new CallbackOperationsService();